export const appHead = {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1, viewport-fit=cover"},{"name":"color-scheme","content":"dark"},{"name":"theme-color","content":"#000000"},{"name":"application-name","content":"绳网"},{"name":"description","content":"绳网（Inter-Knot）是绝区零玩家论坛：攻略、角色讨论、剧情考据和同人创作，新艾利都最大的匿名委托中枢。"},{"property":"og:type","content":"website"},{"property":"og:site_name","content":"绳网"},{"property":"og:title","content":"绳网 - 绝区零玩家论坛"},{"property":"og:description","content":"绳网（Inter-Knot）是绝区零玩家论坛：攻略、角色讨论、剧情考据和同人创作，新艾利都最大的匿名委托中枢。"},{"property":"og:image","content":"https://interk.net/icon/globe-512x512.png"},{"name":"twitter:card","content":"summary_large_image"}],"link":[{"rel":"icon","type":"image/png","sizes":"16x16","href":"/icon/favicon-16x16.png"},{"rel":"icon","type":"image/png","sizes":"32x32","href":"/icon/favicon-32x32.png"},{"rel":"icon","type":"image/png","sizes":"48x48","href":"/icon/favicon-48x48.png"},{"rel":"icon","type":"image/png","sizes":"96x96","href":"/icon/globe-96x96.png"},{"rel":"icon","type":"image/png","sizes":"192x192","href":"/icon/android-chrome-192x192.png"},{"rel":"icon","type":"image/png","sizes":"512x512","href":"/icon/android-chrome-512x512.png"},{"rel":"apple-touch-icon","sizes":"180x180","href":"/icon/apple-touch-icon-180x180.png"},{"rel":"preload","as":"image","href":"/images/loading.gif","fetchpriority":"high"},{"rel":"preconnect","href":"https://im.tiwat.cn"}],"style":[],"script":[{"type":"application/ld+json","innerHTML":"{\"@context\":\"https://schema.org\",\"@type\":\"WebSite\",\"name\":\"绳网\",\"alternateName\":\"INTER-KNOT\",\"description\":\"绳网（Inter-Knot）是绝区零玩家论坛：攻略、角色讨论、剧情考据和同人创作，新艾利都最大的匿名委托中枢。\",\"url\":\"https://interk.net/\",\"inLanguage\":\"zh-CN\",\"about\":{\"@type\":\"VideoGame\",\"name\":\"绝区零\",\"alternateName\":\"Zenless Zone Zero\"}}"}],"noscript":[],"title":"绳网 - 绝区零玩家论坛","htmlAttrs":{"lang":"zh-CN"}}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = {"enabled":false}

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const componentIslandsActive = false

export const payloadExtraction = false

export const prefetchPreloadTags = false

export const cookieStore = true

export const appManifest = true

export const serverPathFallback = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"deep":false}

export const useStateDefaults = {"resetOnClear":false}

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = true

export const spaLoadingTemplateOutside = true

export const purgeCachedData = true

export const granularCachedData = true

export const stripNeverHydratedData = false

export const pendingWhenIdle = false

export const alwaysRunFetchOnKeyChange = false

export const routeTypedFetch = false

export const asyncCallHook = true

export const clientNodePlaceholder = false

export const tracingChannelNuxt = false

export const runtimeCompiler = false

export const vapor = false

export const rawVaporSlotKey = undefined

export const hasPluginDependencies = false

export const hasParallelPlugins = false

export const hasPluginHooks = true

export const hasIslandOptOutPlugins = false